import script from "./ConfirmationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationForm.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationForm.vue?vue&type=style&index=0&id=ffee5672&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffee5672"]])

export default __exports__